import * as Act from '@/services/legal-ad-form/components/act';
import * as Company from '@/services/legal-ad-form/components/company';
import * as HeadOffice from '@/services/legal-ad-form/components/head-office';
import * as OwnerList from '@/services/legal-ad-form/components/owner-list';
import { trimObject } from '@/shared/utils';

export default {
  id: 'scea',
  label: 'Avis de constitution SCEA',
  shortLabel: 'Avis de constitution',
  componentsData: {
    act: { type: '' },
    company: { legalForm: 'Société civile d\'exploitation agricole' },
    headOffice: {},
    ownerList: []
  },
  component: () => import('@/components/legal-ads/forms/models/registration/scea.vue'),
  validate(modelData) {
    return trimObject({
      act: Act.validate(modelData.act),
      company: Company.validate(modelData.company, { skip: ['sharesTransferClause'] }),
      headOffice: HeadOffice.validate(modelData.headOffice),
      ownerList: OwnerList.validate(modelData.ownerList),
    });
  },
  buildContent(modelData) {
    return [
      Act.buildContent(modelData.act, 'société'),
      Company.buildContent(modelData.company),
      HeadOffice.buildContent(modelData.headOffice),
      OwnerList.buildContent(modelData.ownerList),
      HeadOffice.buildRegistrationContent(modelData.headOffice),
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};